<div class="tab-bar" [ngClass]="indicatorStyle" [class.mobile]="mobile">
    <ol cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!draggable" [class.stretch]="stretchItems">
        @for (item of _items; track item.id) {
            <li kui-action cdkDrag [class.active]="isSelected(item)" [class.disabled]="item.disabled" class="text-truncate" [id]="item.id" [title]="item.title" (click)="emitSelection(item)">
                @if (item.icon) {
                    <kui-icon class="tab-icon pr-1" [name]="item.icon"></kui-icon>
                }

                <span class="text-truncate" [title]="item.title">{{ item.title }}</span>

                @if (closeButton) {
                    <kui-icon name="times" class="close ml-2" (click)="emitClose(item, $event)"></kui-icon>
                }
            </li>
        }
    </ol>
</div>
